import {
  CommissionMutationInput,
  useGetCommission,
  useUpdateCommission,
} from 'api-hooks/commission';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useDismiss from 'hooks/use-dismiss';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import React from 'react';
import { NavigationProps } from 'types';

import CommissionForm from './components/form';
import { CommissionMethodType } from './components/form-type';

export type CommissionViewParams = {
  id: string;
};

export default function CommissionView(
  props: NavigationProps<NavigationRoutes.CommissionView>,
) {
  const { mutateAsync, error } = useUpdateCommission();
  const { query: params } = useRouter();
  const id = params?.id as string;
  const query = useGetCommission({ id });
  const onDismiss = useDismiss('commission-masters', id);
  const onSubmit = React.useCallback(
    async (values: CommissionMutationInput, form: CommissionMethodType) => {
      const result = await mutateAsync({
        id,
        body: values,
      });

      onDismiss(result.data.id);

      return result.data;
    },
    [id, mutateAsync, onDismiss],
  );

  return (
    <FetchWrapperComponent
      onRetry={query.refetch}
      loadingComponent={<LoadingComponent />}
      error={!!query.error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={query.refetch} />
        </DetailContainer>
      }
      isLoading={query.isFetching}
      component={
        <>
          {!!error?.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => error.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )}

          <CommissionForm
            {...props}
            commission={query.data?.data}
            onSubmit={onSubmit}
          />
        </>
      }
    />
  );
}
